import { Grid, Paper, Typography } from "@mui/material";
import NumberFormat from "common/components/NumberFormat";
import React from "react";

export default function OverviewReport({ title, amount, sxProp }) {
  return (
    <>
      <Paper elevation={3} sx={{ minWidth: 240, p: 2, mx: 2, my: 2 }}>
        <Grid container>
          <Grid item xs={12} sx={{ textAlign: "center", p: 2 }}>
            <div className="text-3xl xl:text-4xl text-gray-600  font-bold">
              <NumberFormat prefix={"$"} number={amount} />
            </div>

            <Typography variant="h6" sx={sxProp}>
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
